import React from "react";
import { Edit } from "react-admin";
import { PrescriberForm } from "./PrescriberForm";

export const PrescriberEdit = (props) => (
  <Edit title="Editar Prescritor" {...props}>
    <PrescriberForm {...props} />
  </Edit>
);
